import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    UpdateTokenUser: "[Update Auth Token] Action",
};

const initialAuthState = {
    user: undefined,
    authToken: undefined,
};

export const reducer = persistReducer({ storage, key: "app-auth", whitelist: ["user", "authToken"] }, (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.Login: {
            return {
                authToken: action.payload.token,
                user: action.payload.user,
            };
        }

        case actionTypes.Logout: {
            routerHelpers.forgotLastLocation();
            return initialAuthState;
        }

        case actionTypes.UserLoaded: {
            return {
                ...state,
                user: action.payload,
            };
        }

        case actionTypes.UpdateTokenUser: {
            return {
                ...state,
                authToken: action.payload.token,
                user: action.payload.user,
            };
        }

        default:
            return state;
    }
});

export const actions = {
    login: (payload) => ({ type: actionTypes.Login, payload }),
    logout: () => ({ type: actionTypes.Logout }),
    requestUser: (payload) => ({ type: actionTypes.UserRequested, payload }),
    fulfillUser: (payload) => ({ type: actionTypes.UserLoaded, payload }),
    updateTokenUser: (payload) => ({ type: actionTypes.UpdateTokenUser, payload }),
};

export function* saga() {}
